import React, { useState, useRef, useEffect, } from "react";
import { useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { useTranslation } from "react-i18next";
import DatePicker from "react-widgets/DatePicker";
import moment from "moment";
import Constants from "../../../../common/Constants";
import { fetchMasterListById } from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";

const DeptTargetForm = (props) => {
    let [quantity, setQuantity] = useState();
    let [quantityInDozen, setQuantityInDozen] = useState();
    const [date, setDate] = useState();
    const [month, setMonth] = useState();
    const [year, setYear] = useState();
    const [validate, setValidate] = useState(false);
    const { t } = useTranslation();
    const formRef = useRef(null);

    const dispatch = useDispatch();

    useEffect(() => {
                    setDate(props.date);
                    setMonth(props.date?.getUTCMonth() + 1);
                    setYear(props.date?.getUTCFullYear());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let param = {
            url: "getDepartmentTarget",
            deptCode: props.data.deptCode,
            month: month ? month : props.month,
            year: year ? year : props.year,
        };

        if (props.data.deptCode) {
            dispatch(fetchMasterListById(param)).then((result) => {
                if (result?.payload?.data) {
                    const record = result?.payload?.data;
                    setQuantityInDozen(record.quantityInDozen);
                    setQuantity(record.quantity);
                    setMonth(record.month);
                    setYear(record.year);
                    setDate(record.date);
                } else {
                    setQuantityInDozen();
                    setQuantity();
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data.deptCode,month]);

    const handleSave = (event) => {
        const form = formRef.current;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setValidate(true);
            return;
        } else {
            setValidate(false);
            const targetdeptObj = {
                deptCode: props.data.deptCode,
                deptName: props.data.deptName,
                quantity: quantity,
                date: date,
                month: month,
                year: year,
                quantityInDozen: quantityInDozen
            };
            props.onSave(targetdeptObj);
        }
    };

    const handleCancel = () => {
        setQuantity();
        setQuantityInDozen();
        props.onHide();
    };

    const { show, onHide, data } = props;
    return (
        <>
            <Modal show={show} onHide={onHide} animation={false} backdrop="static">
                <ModalHeader
                    title={t("msg_master_list.msg_department.detartment_target_title")}
                ></ModalHeader>
                <ModalBody>
                    <Form noValidate validated={validate} ref={formRef}>
                        <Form.Group
                            className="mb-3 d-flex flex-column"
                            controlId="exampleForm.ControlInput1"
                        >
                            <Form.Label className="d-block">
                                {data.deptCode}: {data.deptName}
                            </Form.Label>
                        </Form.Group>

                        <Form.Group
                            className="mb-3 d-flex flex-column"
                            controlId="exampleForm.ControlInput1"
                        >
                            <Form.Label className="d-block">
                                {t("msg_master_list.msg_department.target_month")}
                            </Form.Label>
                            <DatePicker
                                required
                                max={new Date()}
                                placeholder="mm yyyy"
                                name="target"
                                value={date ? new Date(date) : null}   // 👈 SET VALUE HERE
                                valueFormat={{ month: "short", year: "numeric" }}
                                calendarProps={{ views: ["year", "decade", "century"] }}
                                onChange={(e) => {
                                    const y = e.getFullYear();
                                    const m = e.getMonth();
                                    setYear(y);
                                    setMonth(m + 1);
                                    setDate(moment(e).format('YYYY-MM-DD') || "")
                                }}
                                autoFocus
                            />
                            <Form.Control.Feedback type="invalid">
                                {t("msg_master_list.msg_department.department_name_validation")}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label className="col-form-label">
                                {t("msg_master_list.msg_department.target_quantity")} :
                            </Form.Label>
                            <Form.Control
                                type="number"
                                value={quantity || ""}
                                onChange={(e) => setQuantity(e.target.value)}
                                required
                                maxLength={Constants.MASTER.VALIDATION.maxLengthCode}
                                autoFocus
                            />
                            <Form.Control.Feedback type="invalid">
                                {t("msg_master_list.msg_department.target_quantity_validation")}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label className="col-form-label">
                                {t("msg_master_list.msg_department.quantity_validation")} :
                            </Form.Label>
                            <Form.Control
                                type="number"
                                value={quantityInDozen || ""}
                                onChange={(e) => setQuantityInDozen(e.target.value)}
                                required
                                maxLength={Constants.MASTER.VALIDATION.maxLengthCode}
                                autoFocus
                            />
                            <Form.Control.Feedback type="invalid">
                                {t("msg_master_list.msg_department.quantity_validation")}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        type="button"
                        variant="success"
                        className="btn btn-success"
                        onClick={handleSave}
                    >
                        {t("msg_common.save")}
                    </Button>
                    <Button
                        type="button"
                        variant="danger"
                        className="btn btn-danger"
                        onClick={handleCancel}
                        data-dismiss="modal"
                    >
                        {t("msg_common.cancel")}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default DeptTargetForm;
